import React, { useRef, useState } from 'react'
import { Button, Popover } from '@material-ui/core'

export const ButtonMenu = ({ children, label }: { children: JSX.Element|JSX.Element[]|string, label: string }) => {
  const [editing, setEditing] = useState(false)
  const usingEl = useRef<HTMLButtonElement>(null)

  return <>
    <Button onClick={() => setEditing(true)} ref={usingEl}>{label}</Button>
    <Popover
      open={editing}
      anchorEl={usingEl.current}
      onClose={() => setEditing(false)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >{children}</Popover>
  </>
}
